import { BatchItem } from '../services/agent.service';

/**
 * Every reason one invoice in a bulk AP batch was flagged.
 *
 * <p><b>What the reported bug was.</b> The chip showed at most two of an invoice's reasons and
 * appended `(+3 more)`. Nothing on the page could expand that, because the remaining reasons were
 * never sent — the agent collapsed them to one string before the batch record was written. Both
 * halves are fixed: the agent sends every reason as `flags`, and this returns all of them. There
 * is deliberately no truncation. Someone who uploaded twenty invoices and got four flagged needs
 * to read four explanations, not a number.
 *
 * <p><b>The summary that used to live here has moved to the agent.</b> It was assembled from a
 * poll response, which only works while the page is open — close the tab and the batch finished
 * with nobody to tell. The agent now writes it into the conversation as the batch completes, so
 * the same text is there in the panel, on the AI-First page, and in a session resumed tomorrow.
 */

/** Every reason one invoice was flagged, deduped, newest contract first. */
export function batchItemFlags(item: BatchItem): string[] {
  // `flags` is the full list; `reason` is the one-sentence chip summary and always its first
  // entry. Falling back to `reason` matters during a rollout: a frontend carrying this change
  // will poll an agent that predates it, and one reason beats none.
  const reasons = item.flags?.length ? item.flags : item.reason ? [item.reason] : [];

  return [...new Set(reasons.map(r => r.trim()).filter(Boolean))];
}

/** True for the states where the reader has something to decide. */
function needsExplaining(item: BatchItem): boolean {
  return item.state === 'failed' || item.state === 'needs-attention';
}
